import React, { useState, useEffect } from 'react';
import moment from 'moment'
import { ActivateDeactivateCoupon } from "../actionButtons/ActivateDeactivateCoupon";
import {
  getCouponLabel,
} from "../../../../../config/constants/Campaign/campaign_constants";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { getCouponApi } from "../../../../../api/coupons/coupons";
import { TableCouponDetails } from "./TableCouponDetails";

function TableRow(props) {
  const { coupon, index, couponCreated } = props;
  const [ toggle, setToggle ] = useState(false);
  const [ couponProducts, setCouponProducts ] = useState([]);

  useEffect( () => {
    if (couponCreated) {
      setToggle(false);
      setCouponProducts([]);
    }
  }, [ couponCreated ] ); // eslint-disable-line react-hooks/exhaustive-deps

  if ( ! coupon) {
    return null;
  }

  const toggleRow = () => {
    if ( !couponProducts || !couponProducts.length) {
      getCouponApi({
        'id': coupon.id,
      }).then((response) => {
        if (response && response.data) {
          setCouponProducts(response.data.coupon_products);
          setToggle(!toggle);
        }
      })
    }

    setToggle(!toggle);
  }

  return (
    <>
      <tr>
        <td>
          <Link
            to="#"
            id={`expand-collapse-documents-${coupon.id}`}
            className="cursor-pointer mr-2 link-icon-color"
            onClick={ () => toggleRow() }
          >
            <FontAwesomeIcon
              size="lg"
              className="mr-2 cursor-pointer"
              pointerEvents="none"
              icon={toggle ? faMinus : faPlus}
            />
          </Link>
          <UncontrolledTooltip
            delay={0}
            target={`expand-collapse-documents-${coupon.id}`}
            modifiers={
              {
                preventOverflow: {
                  enabled: true,
                  boundariesElement: 'body'
                }
              }
            }
          >
            {
              toggle ? <FormattedMessage id="components.pages.ticket.table.table_row.collapse_message"/> :
                <FormattedMessage id="components.pages.ticket.table.table_row.expand_message"/>
            }
          </UncontrolledTooltip>
        </td>
        <td>{ coupon.code }</td>
        <td>{ getCouponLabel(coupon.type) }</td>
        <td>{ moment(coupon.start_date).format("yyyy-MM-DD") }</td>
        <td>{ moment(coupon.end_date).format("yyyy-MM-DD") }</td>
        <td>{ moment(coupon.created_at).format("yyyy-MM-DD HH:mm:ss") }</td>
        <td>{ moment(coupon.updated_at).format("yyyy-MM-DD HH:mm:ss") }</td>
        <td className="w-10">
          <ActivateDeactivateCoupon
            coupon={ coupon }
            index={ index }
          />
        </td>
      </tr>
      {
        toggle ? <TableCouponDetails coupon={ coupon } couponProducts={ couponProducts } index={ index } /> : null
      }
    </>
  )
}

export { TableRow };
